import React, { useState, useEffect } from "react";
import { CardText, Card, CardBody } from "reactstrap";
import { listAllScheduledPayments } from "../api/AutopayApi";
import { showApiError } from "../utils/errorRoutingUtils";
import {
	CurrencyDisplayElement,
	DateDisplayElement,
} from "../features/deal/components/DisplayElement";
import ReactTable from "../components/tables/ReactTable";
const ScheduledPayments = ({ autopayId }) => {
	const [isLoading, setIsLoading] = useState(true);
	const [scheduledPayments, setScheduledPayments] = useState([]);
	// — columns for scheduled payments
	const shortColumns = [
		{ Header: "#", accessor: (_r, idx) => idx + 1, style: { width: 20 } },
		{
			Header: "Due Date",
			accessor: "dueDate",
			Cell: ({ value }) => <DateDisplayElement val={value} />,
		},
		{
			Header: "Receipt#",
			accessor: "transactionId",
			Cell: ({ value }) => {
				const str = value != null ? String(value) : "";
				// if it's shorter than 8, just show the whole thing
				return str.length > 8 ? str.slice(-10) : str;
			},
		},
		{
			Header: "Amount",
			accessor: "amount",
			Cell: ({ value }) => <CurrencyDisplayElement val={value} />,
		},
		{
			Header: "Status",
			accessor: "code",
			Cell: ({ value }) => {
				const labels = ["Unpaid", "Paid", "Declined", "Canceled"];
				return labels[value] ?? "Unknown";
			},
		},
	];
	useEffect(() => {
		listAllScheduledPayments(autopayId).then(
			(res) => {
				console.log(res);
				setScheduledPayments(res.data.content);
				setIsLoading(false);
			},
			(err) => {
				if (!err.isGeneralError) {
					showApiError(err, retrieveFailAlert);
				}
			}
		);

		// eslint-disable-next-line
	}, []);
	return (
		<>
			<Card className="mt-3">
				<CardBody>
					{!isLoading && (
						<ReactTable data={scheduledPayments} columns={shortColumns} />
					)}
				</CardBody>
			</Card>
		</>
	);
};
export default ScheduledPayments;
